<template>
  <div class="pt-1 pb-3 px-4">
    <div class="calendar-settings-bar pb-0">
      <div
        style="margin-right: -125px; margin-left: auto; align-items: center;"
      >
        <v-btn-toggle v-model="viewMode" mandatory>
          <v-btn
            :title="
              viewMode === 'gregorian'
                ? 'You are currently viewing the Gregorian calendar'
                : 'Toggle to switch to the Gregorian calendar'
            "
            flat
            value="gregorian"
            small
            >Gregorian Mode</v-btn
          >
          <v-btn
            :title="
              viewMode === 'jewish'
                ? 'You are currently viewing the Jewish calendar'
                : 'Toggle to switch to the Jewish calendar'
            "
            flat
            value="jewish"
            small
            >Yiddish Mode</v-btn
          >
        </v-btn-toggle>
      </div>
      <div style="margin-right: 0; margin-left: auto;  align-items: center;">
        <v-btn-toggle @change="languageChanged" v-model="language" mandatory>
          <v-btn
            :title="
              language === 'en'
                ? 'The calendar is in English'
                : 'Toggle to switch to English'
            "
            flat
            value="en"
            small
            >English</v-btn
          >
          <v-btn
            :title="
              language === 'he'
                ? 'The calendar is in Yiddish'
                : 'Toggle to switch to Yiddish'
            "
            flat
            value="he"
            small
            >אידיש</v-btn
          >
        </v-btn-toggle>
      </div>
    </div>

    <div
      class="mt-0 pt-0"
      style="display: flex; align-items: center; position: relative;"
    >
      <v-layout row justify-space-between class="mt-0 pt-0">
        <v-btn
          small
          class="cal-action-btn"
          style="width: 160px !important;"
          color="success"
          outline
          title="Export to Excel"
          @click="exportDialog = true"
        >
          <v-icon left small>mdi-file-export</v-icon>
          Export date data
        </v-btn>

        <v-layout row style="display: flex; justify-content: center;">
          <v-btn
            class="cal-action-btn mr-2"
            color="success"
            outline
            @click="goToCurrentMonth()"
            title="Go to Current Month"
          >
            Current Month
          </v-btn>
          <v-btn
            class="cal-action-btn"
            color="success"
            outline
            @click="prevMonth()"
            title="Previous Month"
          >
            <v-icon left>mdi-chevron-left</v-icon>
            Prev
          </v-btn>
          <div class="px-3 mt-3" style="text-align: center;">
            <div v-if="viewMode === 'jewish'">
              <div class="headline">
                {{ currentHebrewMonthLabel }}
              </div>
              <div>
                {{ currentGregorianMonthLabel }}
              </div>
            </div>
            <div v-else>
              <div class="headline">
                {{ currentGregorianMonthLabel }}
              </div>
              <div>
                {{ currentHebrewMonthLabel }}
              </div>
            </div>
          </div>
          <v-btn
            class="cal-action-btn"
            color="success"
            outline
            @click="nextMonth()"
            title="Next Month"
          >
            Next
            <v-icon right>mdi-chevron-right</v-icon>
          </v-btn>
          <v-btn
            class="cal-action-btn ml-2"
            color="success"
            outline
            @click="goToMounthDialog = true"
            title="Quick Jump to Month"
          >
            <v-icon left small>mdi-calendar-search</v-icon>
            Go to Month
          </v-btn>
        </v-layout>
        <v-btn
          style="width: 160px !important;"
          :loading="loadingPrint"
          class="cal-action-btn"
          color="success"
          outline
          title="Print calendar months"
          @click="printDialog = true"
        >
          <v-icon left small>mdi-printer </v-icon>
          Print
        </v-btn>
      </v-layout>
    </div>
    <div
      v-if="currentMoladLabel && viewMode === 'jewish'"
      dir="auto"
      class="pt-1"
      style="font-size: 14px; text-align: center; font-weight: 400;"
    >
      {{ currentMoladLabel }}
    </div>
    <div
      style="text-align: center; font-size: 14px;  display: flex; align-items: center; justify-content: center; gap: 4px;"
    >
      <span style="font-size: 15px !important; font-weight: 500 !important;">
        {{ language === "en" ? "Times displayed for " + currentLocation : "" }}
      </span>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <span
            v-on="on"
            style="cursor: pointer; font-weight:bolder; text-decoration: underline; font-size: 15px;"
            >change</span
          >
        </template>
        <v-list dense>
          <v-list-tile
            v-for="loc in locations"
            :key="loc.name"
            @click="
              currentLocation = loc.name;
              loadDayData();
            "
          >
            <v-list-tile-title style="font-size: 13px;">{{
              loc.name
            }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <span style="font-size: 15px !important; font-weight: 600 !important;">{{
        language === "en"
          ? ""
          : "הזמנים הם לפי עיר " +
            locations.find((l) => l.name === currentLocation).yiddish
      }}</span>
    </div>
    <v-flex class="pt-0" style="display: flex; justify-content: center;">
      <v-sheet width="100%">
        <div v-if="loading" class="calendar-loading-overlay">
          <v-progress-circular
            indeterminate
            color="success"
            size="60"
          ></v-progress-circular>
        </div>
        <v-calendar
          class="calendar-container"
          @change="loadDayData"
          ref="calendar"
          type="custom-weekly"
          :start="calendarStart"
          :end="calendarEnd"
        >
          <template v-slot:day="{ date }">
            <template v-if="dayDataMap[date]">
              <div
                @click="openZmanimDialog(date)"
                class="day-bg"
                title="View zmanim"
                :class="{
                  'day-bg-outside-month':
                    dayDataMap[date].isOutsidePrimaryMonth,
                }"
                :style="{ backgroundColor: dayDataMap[date].bgColor }"
              ></div>
              <div
                :class="{
                  'day-content-outside-month':
                    dayDataMap[date].isOutsidePrimaryMonth,
                }"
              >
                <div v-if="viewMode === 'jewish'">
                  <div style="direction: rtl;" class="day-label-1">
                    {{ dayDataMap[date].hebrewDay }}
                  </div>
                  <div class="day-label-2">
                    {{ dayDataMap[date].gregorianLabel }}
                  </div>
                </div>
                <div v-else>
                  <div class="day-label-1">
                    {{ dayDataMap[date].gregorianLabel.split(" ")[1] }}
                  </div>
                  <div style="direction: rtl;" class="day-label-2">
                    {{ dayDataMap[date].hebrewDay }}
                    {{ dayDataMap[date].hebrewMonth }}
                  </div>
                </div>
                <div
                  v-if="!dayDataMap[date].parsha.isSaturday"
                  class="day-label-holiday"
                >
                  {{ dayDataMap[date].holiday }}
                </div>
                <div v-else class="day-label-parsha">
                  {{ dayDataMap[date].parsha.parshaText }}
                  <span v-if="dayDataMap[date].holiday">
                    <span
                      v-if="
                        dayDataMap[date].holiday &&
                          dayDataMap[date].parsha.parshaText
                      "
                    >
                      - {{ dayDataMap[date].holiday }}
                    </span>
                    <span style="color: #f44336;" v-else>
                      {{ dayDataMap[date].holiday }}
                    </span>
                  </span>
                </div>
                <div class="day-label-zmanim">
                  {{ dayDataMap[date].zmanim }}
                </div>
              </div>
            </template>
          </template>
        </v-calendar>
      </v-sheet>
    </v-flex>
    <div
      v-if="nextMoladLabel && !nextMoladLabel.includes('מולד תשרי')"
      dir="auto"
      class="pt-2 pr-4"
      style="text-align: right; font-weight: bold; font-size: 14px;"
    >
      * {{ nextMoladLabel }}
    </div>
    <calendar-export-dialog
      v-model="exportDialog"
      :default-start-date="calendarStartDate"
      :default-end-date="calendarEndDate"
      @export="handleCalendarExport"
    />
    <CalendarPrintDialog
      v-model="printDialog"
      :view-mode="viewMode"
      :default-hebrew-month="hebrewMonth && hebrewMonth.month"
      :default-hebrew-year="hebrewMonth && hebrewMonth.year"
      :default-gregorian-month="
        gregorianMonth
          ? gregorianMonths[gregorianMonth.month - 1]
          : goToDate.gregorianMonth
      "
      :default-gregorian-year="
        (gregorianMonth && gregorianMonth.year) ||
          Number(goToDate.gregorianYear)
      "
      :loading="loadingPrint"
      @print="handleCalendarPrint"
    />
    <v-dialog
      v-model="goToMounthDialog"
      max-width="500"
      content-class="dialog-top"
    >
      <v-card>
        <v-card-title
          style="background-color: #5cb860; color: white; justify-content: center;"
          class="headline py-2"
          ><v-icon color="white" left small>mdi-calendar-search</v-icon>Go to
          Month</v-card-title
        >
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs4>
              <v-select
                v-model="goToDate.gregorianMonth"
                :items="gregorianMonths"
                label="Month"
              ></v-select>
            </v-flex>
            <v-flex xs3 class="pl-2">
              <v-text-field
                v-model="goToDate.gregorianYear"
                label="Year"
                :rules="[
                  (value) => {
                    if (isNaN(value) || value.length < 4)
                      return 'Enter 4 digit year';
                    if (value > 2239 || value < 1240)
                      return 'Enter a valid Gregorian year from 1240 to 2240';
                    return true;
                  },
                ]"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-btn
                style="font-weight:600 !important;"
                :disabled="
                  !goToDate.gregorianMonth ||
                    !goToDate.gregorianYear ||
                    isNaN(goToDate.gregorianYear) ||
                    goToDate.gregorianYear < 1240 ||
                    goToDate.gregorianYear > 2239
                "
                flat
                color="success"
                @click="goToGregorianMonth()"
                >{{
                  "Go To - " +
                    goToDate.gregorianMonth +
                    " " +
                    goToDate.gregorianYear
                }}</v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs2>
              <v-select
                v-model="goToDate.hebrewMonth"
                :items="hebrewMonths"
                label="חודש"
                style="direction: rtl;"
              >
                <template slot="item" slot-scope="{ item }">
                  <span style="direction: rtl;">{{ item }}</span>
                </template>
              </v-select>
            </v-flex>
            <v-flex xs5 class="pl-2">
              <v-layout row no-wrap>
                <v-flex xs6 class="pr-1">
                  <v-text-field
                    v-model="goToDate.hebrewYear"
                    label="שנת"
                    :rules="[
                      (value) => {
                        if (isNaN(value)) return 'Enter 4 digit year';
                        if (value < 5000) return 'Enter from 5000';
                        if (value > 5999) return 'Enter till 6000';
                        return true;
                      },
                    ]"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 class="pl-1">
                  <v-select
                    v-model="goToDate.hebrewYear"
                    :items="hebrewYears"
                    item-text="text"
                    item-value="value"
                    style="direction: rtl;"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs4>
              <v-btn
                style="font-weight:600 !important;"
                :disabled="
                  !goToDate.hebrewMonth ||
                    !goToDate.hebrewYear ||
                    goToDate.hebrewYear < 5000 ||
                    goToDate.hebrewYear > 5999
                "
                flat
                color="success"
                @click="goToHebrewMonth()"
                >{{
                  "Go To - " +
                    goToDate.hebrewMonth +
                    " " +
                    gematriya(goToDate.hebrewYear, 3)
                }}</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" small dark @click="goToMounthDialog = false"
            >Cancel</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="zmanimDialog" max-width="400">
      <v-card>
        <v-card-title
          style="background-color: #5cb860; color: white; justify-content: center;"
          class="headline py-2"
        >
          <v-icon color="white" left small>mdi-clock-outline</v-icon>
          {{ selectedZmanimDateLabel }}
        </v-card-title>
        <v-card-text class="pb-0" style="direction: rtl;">
          <v-layout
            v-for="item in selectedZmanimList"
            :key="item.key"
            row
            justify-space-between
            class="py-1"
            style="direction: ltr; align-items: center;"
          >
            <div
              v-if="language === 'en'"
              style="font-weight: 400; color: #444; text-align: left;"
            >
              {{ item.enLabel }}
            </div>
            <div
              v-if="language === 'en'"
              style="flex: 1; border-bottom: 1px dotted #9e9e9e; margin: 0 10px;"
            ></div>
            <div
              style="font-weight: 400; width: 24%; color: green; text-align: center;"
            >
              {{ item.value }}
            </div>
            <div
              v-if="language === 'he'"
              style="flex: 1; border-bottom: 1px dotted #9e9e9e; margin: 0 10px;"
            ></div>
            <div
              v-if="language === 'he'"
              style=" font-weight: 600; color: #444; text-align: right; direction: rtl;"
            >
              {{ item.label }}
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" small dark @click="zmanimDialog = false"
            >close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import {
  HDate,
  HebrewCalendar,
  getHolidaysOnDate,
  getSedra,
  Locale,
  gematriya,
  gematriyaStrToNum,
  Location,
  Zmanim,
  Molad,
} from "@hebcal/core";
import moment from "moment";
import CalendarExportDialog from "./CalendarExportDialog.vue";
import CalendarPrintDialog from "./CalendarPrintDialog.vue";
import { exportCalendarToExcel, exportCalendarToPdf } from "./calendarExport";

const SHORT_MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const HEBREW_WEEKDAY_NAMES = [
  { short: "א׳", long: "ראשון", yiddish: "זונטאג" },
  { short: "ב׳", long: "שני", yiddish: "מאנטאג" },
  { short: "ג׳", long: "שלישי", yiddish: "דינסטאג" },
  { short: "ד׳", long: "רביעי", yiddish: "מיטוואך" },
  { short: "ה׳", long: "חמישי", yiddish: "דאנערשטאג" },
  { short: "ו׳", long: "שישי", yiddish: "פרייטאג" },
  { short: "ש׳", long: "שבת", yiddish: "שבת קודש" },
];
const ALLOWED_HOLIDAYS = [
  { mask: 128, description: "Rosh Chodesh", majorHoliday: false },
  { mask: 512, description: "Special Shabbat", majorHoliday: false },
  { mask: 256, description: "Minor Fast", majorHoliday: false },
  {
    mask: 1048586,
    description: "Erev Pesach - Sukkot",
    majorHoliday: false,
  },
  { mask: 41, description: "Yom Tov I", majorHoliday: true },
  { mask: 13, description: "Yom Tov II", majorHoliday: true },
  { mask: 2097160, description: "CH''M", majorHoliday: true },
  { mask: 2097162, description: "CH''M", majorHoliday: true },
  { mask: 524288, description: "Minor Holiday", majorHoliday: false },
  { mask: 1048578, description: "Erev Holiday", majorHoliday: false },
  { mask: 1064960, description: "Erev Tish'a B'Av", majorHoliday: false },
  { mask: 16384, description: "Tish'a B'Av", majorHoliday: true },
  { mask: 33, description: "Rosh Hashana I", majorHoliday: true },
  { mask: 5, description: "Rosh Hashana II", majorHoliday: true },
  { mask: 16389, description: "Yom Kippur", majorHoliday: true },
  { mask: 2097154, description: "Hoshana Raba", majorHoliday: true },
  { mask: 1572928, description: "Chanukah: 1 Candle", majorHoliday: false },
  { mask: 524352, description: "Chanukah Candles", majorHoliday: false },
];
const ALLOWED_HOLIDAY_MASK_NUMBER = new Set(
  ALLOWED_HOLIDAYS.map((holiday) => holiday.mask)
);
const ALLOWED_MAJOR_HOLIDAY_MASK_NUMBER = new Set(
  ALLOWED_HOLIDAYS.filter((holiday) => holiday.majorHoliday).map(
    (holiday) => holiday.mask
  )
);
const EXCLUDED_HOLIDAY_DESCRIPTION = new Set([
  "Chag HaBanot",
  "Rosh Hashana LaBehemot",
  "Ta'anit Bechorot",
]);

export default {
  components: {
    CalendarExportDialog,
    CalendarPrintDialog,
  },
  data: () => ({
    title: "Calendar",
    viewMode: "jewish",
    hebrewMonth: null,
    gregorianMonth: null,
    loading: false,
    loadingPrint: false,
    dayDataMap: {},
    zmanimDialog: false,
    selectedZmanimList: [],
    selectedZmanimDateLabel: "",
    goToMounthDialog: false,
    exportDialog: false,
    printDialog: false,
    calendarStartDate: "",
    calendarEndDate: "",
    goToDate: {
      gregorianMonth: moment().month() + 1,
      gregorianYear: moment().year(),
      hebrewMonth: "",
      hebrewYear: "",
    },
    gregorianMonths: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    hebrewMonths: [
      "תשרי",
      "חשוון",
      "כסלו",
      "טבת",
      "שבט",
      "אדר",
      "אדר א׳",
      "אדר ב׳",
      "ניסן",
      "אייר",
      "סיוון",
      "תמוז",
      "אב",
      "אלול",
    ],
    currentGregorianMonthLabel: "",
    currentHebrewMonthLabel: "",
    currentMoladLabel: "",
    nextMoladLabel: "",
    language: "he",
    currentLocation: "New York",
    locations: [
      { name: "New York", yiddish: "ניו יארק", lat: 40.73061, lng: -73.935242 },
      {
        name: "Monsey",
        yiddish: "מאנסי",
        lat: 41.11833286,
        lng: -74.059499762,
      },
      {
        name: "Kiryas Yoel",
        yiddish: "קרית יואל",
        lat: 41.324167,
        lng: -74.186944,
      },
      {
        name: "Kiryas Yetev Lev (Bloomingburg)",
        yiddish: "קרית יטב לב",
        lat: 41.553664452,
        lng: -74.437998248,
      },
      {
        name: "Catskills",
        yiddish: "קעטסקילס",
        lat: 42.217312,
        lng: -73.864571,
      },
      {
        name: "Montreal",
        yiddish: "מאנטריאל",
        lat: 45.508888,
        lng: -73.561668,
      },
      //   {
      //     name: "Jerusalem",
      //     yiddish: "ירושלים",
      //     lat: 31.771959,
      //     lng: 35.217018,
      //   },
      //   {
      //     name: "London",
      //     yiddish: "לונדון",
      //     lat: 51.509865,
      //     lng: -0.118092,
      //   },
      //   {
      //     name: "Manchester",
      //     yiddish: "מאנטשעסטער",
      //     lat: 53.483959,
      //     lng: -2.244644,
      //   },
      //   {
      //     name: "Antwerp",
      //     yiddish: "אנטווערפען",
      //     lat: 51.260197,
      //     lng: 4.402771,
      //   },
    ],
  }),
  metaInfo() {
    return {
      title: `${this.title}`,
    };
  },
  created() {
    this.locations.forEach(({ name, lat, lng }) => {
      Location.addLocation(
        name,
        new Location(lat, lng, false, "America/New_York")
      );
    });

    const today = new HDate(new Date());
    this.hebrewMonth = { month: today.getMonth(), year: today.getFullYear() };
    this.gregorianMonth = {
      month: moment().month() + 1,
      year: moment().year(),
    };
    this.restoreSettings();

    // this.gregorianPageStart = moment()
    //   .startOf("month")
    //   .format("YYYY-MM-DD");

    this.loadDayData();

    // Suppress Vue warnings
    this._prevWarnHandler = Vue.config.warnHandler;
    Vue.config.warnHandler = (msg, vm, trace) => {
      if (msg.includes(".native modifier")) return;
      (this._prevWarnHandler || console.warn.bind(console, "[Vue warn]:"))(
        msg,
        vm,
        trace
      );
    };
  },

  watch: {
    viewMode(newMode) {
      localStorage.setItem("calendar.viewMode", newMode);
      if (newMode === "gregorian" && this.hebrewMonthDays.length) {
        const date = moment(this.hebrewMonthDays[0].greg()).format(
          "YYYY-MM-DD"
        );
        // this.gregorianMonth = {
        //   month: moment(date).month() + 1,
        //   year: moment(date).year(),
        // };
      } else if (newMode === "jewish" && this.gregorianMonth) {
        const hd = new HDate(
          moment(
            `${this.gregorianMonth.year}-${this.gregorianMonth.month}-01`
          ).toDate()
        );
        this.hebrewMonth = { month: hd.getMonth(), year: hd.getFullYear() };
      }
    },
    language(newLanguage) {
      localStorage.setItem("calendar.language", newLanguage);
    },
    currentLocation(newLocation) {
      localStorage.setItem("calendar.currentLocation", newLocation);
    },
  },
  computed: {
    hebrewYears() {
      return Array.from({ length: 101 }, (_, index) => {
        const year = 5770 + index;
        return {
          text: gematriya(year, 3),
          value: year,
        };
      });
    },
    hebrewMonthDays() {
      if (!this.hebrewMonth) return [];
      const firstDay = new HDate(
        1,
        this.hebrewMonth.month,
        this.hebrewMonth.year
      );
      return Array.from({ length: firstDay.daysInMonth() }, (_, i) => {
        return new HDate(i + 1, this.hebrewMonth.month, this.hebrewMonth.year);
      });
    },
    calendarStart() {
      if (this.viewMode === "jewish") {
        if (!this.hebrewMonthDays.length) return "";
        return this.toISODate(this.hebrewMonthDays[0].greg());
      } else {
        return `${this.gregorianMonth.year}-${this.gregorianMonth.month}-01`;
      }
    },
    calendarEnd() {
      if (this.viewMode === "jewish") {
        if (!this.hebrewMonthDays.length) return "";
        return this.toISODate(
          this.hebrewMonthDays[this.hebrewMonthDays.length - 1].greg()
        );
      } else {
        return `${this.gregorianMonth.year}-${
          this.gregorianMonth.month
        }-${moment(
          `${this.gregorianMonth.year}-${this.gregorianMonth.month}`,
          "YYYY-M"
        ).daysInMonth()}`;
      }
    },
  },
  methods: {
    restoreSettings() {
      const savedViewMode = localStorage.getItem("calendar.viewMode");
      if (savedViewMode === "jewish" || savedViewMode === "gregorian") {
        this.viewMode = savedViewMode;
      }
      const savedLanguage = localStorage.getItem("calendar.language");
      if (savedLanguage === "he" || savedLanguage === "en") {
        this.language = savedLanguage;
      }
      const savedLocation = localStorage.getItem("calendar.currentLocation");
      if (
        savedLocation &&
        this.locations.some((l) => l.name === savedLocation)
      ) {
        this.currentLocation = savedLocation;
      }
    },
    openZmanimDialog(date) {
      const dayData = this.dayDataMap[date];
      if (!dayData || !dayData.zmanimDetails) return;
      this.selectedZmanimList = dayData.zmanimDetails;
      const hebrewDateLabel = `${dayData.hebrewDay} ${dayData.hebrewMonth} ${
        dayData.hebrewYear
      }`;
      this.selectedZmanimDateLabel = `${
        dayData.gregorianLabel
      } - ${hebrewDateLabel}`;
      this.zmanimDialog = true;
    },
    gematriya(value, style) {
      if (!value || !style) return;
      return gematriya(value, style);
    },

    getMoladHDate(year, month) {
      const m = new Molad(year, month);
      let abs = new HDate(1, month, year).abs(); // Rosh Chodesh
      while (((abs % 7) + 7) % 7 !== m.getDow()) abs--; // Backtrack until 3 days
      return new HDate(abs);
    },

    getMoladLabel(year, month) {
      const molad = new Molad(year, month);
      const moladHDate = this.getMoladHDate(year, month);

      const moladHeb = `מולד ${Locale.gettext(
        molad.getMonthName(),
        "he"
      ).replace(/[\u0591-\u05C7]/g, "")}: יום ${
        ["ראשון", "שני", "שלישי", "רביעי", "חמישי", "שישי", "שבת"][
          molad.m.dayOfWeek
        ]
      }
         ${gematriya(moladHDate.getDate())} ${Locale.gettext(
        moladHDate.getMonthName(),
        "he"
      ).replace(/[\u0591-\u05C7]/g, "")}
           בשעה \u2068${molad.m.hour % 12 || 12}:${
        molad.m.minutes < 10 ? "0" + molad.m.minutes : molad.m.minutes
      } ${molad.m.hour < 12 ? "AM" : "PM"}\u2069${
        molad.m.chalakim > 0
          ? " ו" + gematriya(molad.m.chalakim, 3) + " חלקים"
          : ""
      }`;

      return this.language === "he" ? moladHeb : molad.render("ashkenazi");
    },

    setCurrentMonthLabel() {
      const hebrewStart = new HDate(
        new Date(`${this.calendarStartDate}T00:00:00`)
      );
      const nextHebrewStart = hebrewStart.add(1, "month");
      const hebrewStartMonth = this.formatHebrewMonthName(hebrewStart.greg());
      const hebrewStartYear = gematriya(hebrewStart.getFullYear(), 3);
      const hebrewEnd = new HDate(new Date(`${this.calendarEndDate}T00:00:00`));
      const hebrewEndMonth = this.formatHebrewMonthName(hebrewEnd.greg());
      const hebrewEndYear = gematriya(hebrewEnd.getFullYear(), 3);
      const gregorianMonthStart = new Intl.DateTimeFormat("en-US", {
        month: "long",
      }).format(new Date(`${this.calendarStartDate}T00:00:00`));
      const gregorianMonthEnd = new Intl.DateTimeFormat("en-US", {
        month: "long",
      }).format(new Date(`${this.calendarEndDate}T00:00:00`));

      const hebrewStartMounthAndYear = hebrewStartMonth + " " + hebrewStartYear;
      const hebrewEndMounthAndYear = hebrewEndMonth + " " + hebrewEndYear;

      this.currentHebrewMonthLabel =
        hebrewStartMounthAndYear == hebrewEndMounthAndYear
          ? hebrewStartMounthAndYear
          : hebrewStartYear == hebrewEndYear
          ? hebrewStartMonth + " - " + hebrewEndMounthAndYear
          : hebrewStartMounthAndYear + " - " + hebrewEndMounthAndYear;

      const gregorianStartYear = new Date(
        `${this.calendarStartDate}T00:00:00`
      ).getFullYear();
      const gregorianEndYear = new Date(
        `${this.calendarEndDate}T00:00:00`
      ).getFullYear();
      const gregorianStartMonthAndYear =
        gregorianMonthStart + " " + gregorianStartYear;
      const gregorianEndMonthAndYear =
        gregorianMonthEnd + " " + gregorianEndYear;

      this.currentGregorianMonthLabel =
        gregorianStartMonthAndYear === gregorianEndMonthAndYear
          ? gregorianStartMonthAndYear
          : gregorianStartYear === gregorianEndYear
          ? gregorianMonthStart + " - " + gregorianEndMonthAndYear
          : gregorianStartMonthAndYear + " - " + gregorianEndMonthAndYear;
      this.goToDate.gregorianMonth = gregorianMonthStart;
      this.goToDate.gregorianYear = gregorianStartYear;
      this.goToDate.hebrewMonth = hebrewStartMonth;
      this.goToDate.hebrewYear = gematriyaStrToNum(hebrewStartYear) + 5000;

      this.currentMoladLabel = this.getMoladLabel(
        hebrewStart.getFullYear(),
        hebrewStart.getMonth()
      );

      this.nextMoladLabel = this.getMoladLabel(
        nextHebrewStart.getFullYear(),
        nextHebrewStart.getMonth()
      );
    },

    async loadDayData() {
      this.dayDataMap = {};
      this.loading = true;
      await new Promise((resolve) => setTimeout(resolve, 0));
      this.dayDataMap = this.computeDayData();
      this.loading = false;
    },
    computeDayData() {
      const map = {};
      const monthDays =
        this.viewMode === "jewish"
          ? this.hebrewMonthDays.map((hd) => ({ hd, greg: hd.greg() }))
          : (() => {
              const result = [];
              const start = moment(
                `${this.gregorianMonth.year}-${this.gregorianMonth.month}-01`
              ).startOf("month");
              const end = moment(
                `${this.gregorianMonth.year}-${this.gregorianMonth.month}-01`
              ).endOf("month");
              for (
                let d = start.clone();
                d.isSameOrBefore(end, "day");
                d.add(1, "day")
              ) {
                const greg = d.toDate();
                result.push({ hd: new HDate(greg), greg });
              }
              return result;
            })();
      this.calendarStartDate = this.toISODate(monthDays[0].greg);
      this.calendarEndDate = this.toISODate(
        monthDays[monthDays.length - 1].greg
      );
      this.setCurrentMonthLabel();
      const monthDateSet = new Set(
        monthDays.map(({ greg }) => this.toISODate(greg))
      );
      const displayStart = moment(monthDays[0].greg).startOf("week");
      const displayEnd = moment(monthDays[monthDays.length - 1].greg).endOf(
        "week"
      );
      const days = [];
      for (
        let d = displayStart.clone();
        d.isSameOrBefore(displayEnd, "day");
        d.add(1, "day")
      ) {
        const greg = d.toDate();
        days.push({ hd: new HDate(greg), greg });
      }
      for (const { greg } of days) {
        const isoDate = this.toISODate(greg);
        map[isoDate] = {
          isOutsidePrimaryMonth: !monthDateSet.has(isoDate),
          ...this.buildDayDataForDate(greg),
        };
      }
      return map;
    },
    toISODate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    prevMonth() {
      let { month, year } = this.hebrewMonth;
      month--;
      if (month < 1) {
        month = HDate.monthsInYear(year);
      } else if (month === 6) {
        year--;
      }
      this.hebrewMonth = { month, year };
      const prevGreg = moment({
        year: this.gregorianMonth.year,
        month: this.gregorianMonth.month - 1,
      }).subtract(1, "month");
      this.gregorianMonth = {
        month: prevGreg.month() + 1,
        year: prevGreg.year(),
      };
    },

    nextMonth() {
      let { month, year } = this.hebrewMonth;
      const maxMonth = HDate.monthsInYear(year);
      month++;
      if (month > maxMonth) {
        month = 1;
      } else if (month === 7) {
        year++;
      }
      this.hebrewMonth = { month, year };
      const nextGreg = moment({
        year: this.gregorianMonth.year,
        month: this.gregorianMonth.month - 1,
      }).add(1, "month");
      this.gregorianMonth = {
        month: nextGreg.month() + 1,
        year: nextGreg.year(),
      };
    },

    goToHebrewMonth() {
      this.viewMode = "jewish";
      const hd = new HDate(
        1,
        this.goToDate.hebrewMonth,
        this.goToDate.hebrewYear
        //gematriyaStrToNum(this.goToDate.hebrewYear) + 5000
      );
      this.hebrewMonth = { month: hd.getMonth(), year: hd.getFullYear() };
      this.goToMounthDialog = false;
    },

    goToGregorianMonth() {
      this.viewMode = "gregorian";
      const parsed = moment(
        `${this.goToDate.gregorianMonth} ${this.goToDate.gregorianYear}`,
        "MMMM YYYY"
      );
      if (!parsed.isValid()) return;
      this.gregorianMonth = { month: parsed.month() + 1, year: parsed.year() };
      this.goToMounthDialog = false;
    },
    goToCurrentMonth() {
      const today = new HDate(new Date());
      this.hebrewMonth = { month: today.getMonth(), year: today.getFullYear() };
      this.gregorianMonth = {
        month: moment().month() + 1,
        year: moment().year(),
      };
      this.goToMounthDialog = false;
    },
    formatHebrewMonthName(gregorianDate) {
      return new Intl.DateTimeFormat("he-u-ca-hebrew", {
        month: "long",
      }).format(gregorianDate);
    },
    formatTimeForRtl(timeText) {
      return `\u200E${timeText}\u200E`;
    },

    async handleCalendarExport({ startDate, endDate, selectedFields }) {
      const rows = this.getExportRows(startDate, endDate);
      exportCalendarToExcel(rows, { startDate, endDate }, selectedFields);
      this.exportDialog = false;
    },

    async handleCalendarPrint({ startDate, endDate }) {
      const previewWindow = window.open("about:blank", "_blank");
      this.loadingPrint = true;
      try {
        const rows = this.getExportRows(startDate, endDate);
        await exportCalendarToPdf(rows, {
          type: this.viewMode,
          language: this.language,
          location:
            this.language === "he"
              ? this.locations.find((l) => l.name === this.currentLocation)
                  .yiddish
              : this.currentLocation,
          getMoladLabel: (year, month) => this.getMoladLabel(year, month),
          previewWindow,
        });
        this.printDialog = false;
      } catch (err) {
        if (previewWindow && !previewWindow.closed) {
          previewWindow.close();
        }
        throw err;
      } finally {
        this.loadingPrint = false;
      }
    },

    isShabbatMevarchim(greg) {
      if (greg.getDay() !== 6) return false;
      for (let i = 1; i <= 7; i += 1) {
        const next = new Date(greg);
        next.setDate(next.getDate() + i);
        const hd = new HDate(next);
        const day = hd.getDate();
        if (day === 1 || day === 30) {
          if (day === 1 && hd.getMonth() === HDate.monthNum("Tishrei")) {
            return false;
          }
          return true;
        }
      }
      return false;
    },

    zmanimFormat(z) {
      return Zmanim.formatTime(
        z,
        new Intl.DateTimeFormat("en-US", {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
    },

    buildDayDataForDate(greg) {
      const hd = new HDate(greg);
      const allholidays = getHolidaysOnDate(hd, false) || [];
      const holidays = allholidays
        .filter((h) => ALLOWED_HOLIDAY_MASK_NUMBER.has(h.mask))
        .filter((h) => !EXCLUDED_HOLIDAY_DESCRIPTION.has(h.desc));

      const isMajorHoliday = holidays.some((holiday) =>
        ALLOWED_MAJOR_HOLIDAY_MASK_NUMBER.has(holiday.mask)
      );
      const isKufAlefKislev =
        hd.getMonth() === 9 && hd.getDate() === 21 && hd.getFullYear() > 5705;
      const is26thOfAv =
        hd.getMonth() === 5 && hd.getDate() === 26 && hd.getFullYear() > 5739;
      const is26thOfNissan =
        hd.getMonth() === 1 && hd.getDate() === 26 && hd.getFullYear() > 5766;

      const isFriday = greg.getDay() === 5;
      const isSaturday = greg.getDay() === 6;
      const isToday =
        new Date().toLocaleDateString() === greg.toLocaleDateString();
      const sedraInfo = getSedra(hd.getFullYear(), false).lookup(hd);

      const parshaText =
        sedraInfo &&
        Array.isArray(sedraInfo.parsha) &&
        sedraInfo.parsha.length &&
        sedraInfo.chag === false
          ? `${sedraInfo.parsha
              .map((name) =>
                Locale.gettext(
                  name,
                  this.language === "he" ? "he" : "ashkenazi"
                )
              )
              .join(" - ")
              .replace(/\u05BE/g, " ")
              .replace(/[\u0591-\u05C7]/g, "")}
              `
          : "";
      const shabbatMevarchimText =
        isSaturday && this.isShabbatMevarchim(greg)
          ? this.language === "he"
            ? "שבת מברכים *"
            : "Shabbos Mevorchim *"
          : "";
      const parshaTextWithMevarchim = [parshaText, shabbatMevarchimText]
        .filter(Boolean)
        .join(" - ");
      let holidayText = isKufAlefKislev
        ? `${
            this.language === "he"
              ? "כא כסליו – יום הצלה רבינו הקדוש"
              : "kuf alef kislev - Yom Ha-tzulas Rabbeinu HaKadosh"
          }`
        : is26thOfAv
        ? `${'יו"ד רביה"ק בעל ויואל משה'}`
        : is26thOfNissan
        ? `${'יו"ד רביה"ק בעל ברך משה'}`
        : holidays.length > 0
        ? holidays
            .map((h) => h.render(this.language === "he" ? "he" : "ashkenazi"))
            .join(", ")
            .replace(/\u05BE/g, " ")
            .replace(/[\u0591-\u05C7]/g, "")
        : "";

      const zmanim = new Zmanim(
        Location.lookup(this.currentLocation),
        greg,
        false
      );

      const zmanimDetails = [
        {
          key: "alotHaShachar",
          label: "עלות השחר",
          enLabel: "Alos Hashachar",
          value: zmanim.alotHaShachar72(),
        },
        {
          key: "neitzHaChama",
          label: "נץ החמה",
          enLabel: "Neitz Hachamah",
          value: zmanim.neitzHaChama(),
        },
        {
          key: "sofZmanShmaMGA",
          label: "סוף זמן קריאת שמע",
          enLabel: "Sof Zman Krias Shema",
          value: zmanim.sofZmanShmaMGA(),
        },
        {
          key: "sofZmanShma",
          label: 'סוף זמן קריאת שמע גר"א',
          enLabel: "Sof Zman Krias Shema (GRA)",
          value: zmanim.sofZmanShma(),
        },
        {
          key: "sofZmanTfillaMGA",
          label: "סוף זמן תפילה",
          enLabel: "Sof Zman Tefillah",
          value: zmanim.sofZmanTfillaMGA(),
        },
        {
          key: "sofZmanTfilla",
          label: 'סוף זמן תפילה גר"א',
          enLabel: "Sof Zman Tefillah (GRA)",
          value: zmanim.sofZmanTfilla(),
        },
        {
          key: "chatzot",
          label: "חצות",
          enLabel: "Chatzos",
          value: zmanim.chatzot(),
        },
        {
          key: "minchaGedola",
          label: "מנחה גדולה",
          enLabel: "Mincha Gedolah",
          value: zmanim.minchaGedolaMGA(),
        },
        {
          key: "minchaKetana",
          label: "מנחה קטנה",
          enLabel: "Mincha Ketanah",
          value: zmanim.minchaKetanaMGA(),
        },
        {
          key: "sunset",
          label: "שקיעה",
          enLabel: "Shkiah",
          value: zmanim.sunset(),
        },
        {
          key: "sunsetOffset72",
          label: 'ר"ת',
          enLabel: "Rabbeinu Tam (72)",
          value: zmanim.sunsetOffset(+72),
        },
      ].map((item) => ({
        key: item.key,
        label: item.label,
        enLabel: item.enLabel,
        value: this.formatTimeForRtl(this.zmanimFormat(item.value)),
      }));

      const firstDayOfJewishYear =
        holidayText.startsWith("ראש השנה") && /\d$/.test(holidayText);
      if (firstDayOfJewishYear) {
        holidayText = "ראש השנה א'";
      }

      return {
        gregorianLabel: SHORT_MONTHS[greg.getMonth()] + " " + greg.getDate(),
        hebrewDay: gematriya(hd.getDate()),
        hebrewMonth: this.formatHebrewMonthName(greg),
        hebrewYear: gematriya(hd.getFullYear(), 3),
        holiday: holidayText ? `${holidayText}` : "",
        parsha: { parshaText: parshaTextWithMevarchim, isSaturday: isSaturday },
        zmanimDetails,
        zmanim: isFriday
          ? `${
              this.language === "he" ? "הדלקת הנרות" : "Candle Lighting"
            }: ${this.formatTimeForRtl(
              this.zmanimFormat(zmanim.sunsetOffset(-15))
            )}`
          : isSaturday
          ? `${
              this.language === "he" ? "מוצאי שבת" : "Motza'ei Shabbas"
            }: ${this.formatTimeForRtl(
              this.zmanimFormat(zmanim.sunsetOffset(+72))
            )}`
          : "",
        bgColor: isToday
          ? "#e8f7fa"
          : isSaturday || isMajorHoliday
          ? "#fff8e1"
          : "#ffffff",
      };
    },

    getExportRows(startDate, endDate) {
      const start = moment(startDate, "YYYY-MM-DD").startOf("day");
      const end = moment(endDate, "YYYY-MM-DD").startOf("day");
      const rows = [];

      for (
        let day = start.clone();
        day.isSameOrBefore(end, "day");
        day.add(1, "day")
      ) {
        const isoDate = day.format("YYYY-MM-DD");
        const dayData =
          this.dayDataMap[isoDate] || this.buildDayDataForDate(day.toDate());
        rows.push({
          gregorianDate: isoDate,
          gregorianDay: isoDate.split("-")[2],
          dayInWeekNameLong: day.format("dddd"),
          dayInWeekNameShort: day.format("ddd"),
          dayInWeekNum: day.day() + 1,
          gregorianMonthName: dayData.gregorianLabel.split(" ")[0],
          gregorianMonthNum: isoDate.split("-")[1],
          gregorianYear: isoDate.split("-")[0],
          hebrewDate: `${dayData.hebrewDay} ${dayData.hebrewMonth}`,
          hebrewDay: dayData.hebrewDay || "",
          hebrewDayInWeekNameShort: HEBREW_WEEKDAY_NAMES[day.day()].short,
          hebrewDayInWeekNameLong: HEBREW_WEEKDAY_NAMES[day.day()].long,
          hebrewDayInWeekNameYiddish: HEBREW_WEEKDAY_NAMES[day.day()].yiddish,
          hebrewMonthName: dayData.hebrewMonth || "",
          hebrewYear: dayData.hebrewYear || "",
          hebrewDayNum: gematriyaStrToNum(dayData.hebrewDay) || "",
          hebrewMonthNum: HDate.monthFromName(dayData.hebrewMonth) || "",
          hebrewYearNum:
            gematriyaStrToNum(dayData.hebrewYear) < 1000
              ? gematriyaStrToNum(dayData.hebrewYear) + 5000
              : gematriyaStrToNum(dayData.hebrewYear) || "",
          holiday: dayData.holiday || "",
          parsha: dayData.parsha.parshaText || "",
          bgColor: dayData.bgColor || "",
          zmanim: dayData.zmanim || "",
        });
      }
      return rows;
    },
    languageChanged(value) {
      this.language = value;
      this.loadDayData();
    },
  },
};
</script>
<style>
.v-calendar-weekly__head-weekday,
.v-calendar-weekly__head th {
  background-color: #e9eef5 !important;
  color: #5cb860 !important;
  font-weight: 600 !important;
  font-size: 0.85em !important;
  text-transform: uppercase !important;
  letter-spacing: 0.04em !important;
  padding: 0.5em 0.75em !important;
  text-align: center !important;
}

.v-calendar-weekly__day {
  min-height: calc((100vh - 120px) / 7) !important;
  position: relative;
}
.day-bg {
  position: absolute;
  inset: 0;
  cursor: pointer;
  transition: filter 0.15s ease;
}
.day-bg:hover {
  filter: brightness(0.95);
}
.day-bg-outside-month {
  opacity: 0.35;
}

.day-content-outside-month {
  opacity: 0.55;
}

.day-label-1 {
  font-size: 1.5em;
  position: absolute;
  top: 0px;
  right: 6px;
  color: #5cb860;
  font-weight: 600;
}
.day-label-2 {
  margin-top: 0px;
  position: absolute;
  right: 6px;
  font-size: 0.85em;
  color: #888;
}
.calendar-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
.day-label-parsha {
  margin-top: 15px;
  direction: rtl;
  position: absolute;
  right: 6px;
  font-size: 0.85em;
  color: #000b87;
  font-weight: 600;
}
.day-label-holiday {
  margin-top: 15px;
  direction: rtl;
  position: absolute;
  right: 6px;
  font-size: 0.85em;
  color: #f44336;
  font-weight: 600;
}

.day-label-zmanim {
  margin-top: 30px;
  direction: rtl;
  position: absolute;
  right: 6px;
  font-size: 0.85em;
  color: #1074bb;
  font-weight: 500;
}
.v-btn.cal-action-btn {
  background: linear-gradient(180deg, #ffffff, #f6fbf6) !important;
  border: 1px solid rgba(92, 184, 96, 0.5) !important;
  border-radius: 8px !important;
  color: #3d8b40 !important;
  font-weight: 600 !important;
  letter-spacing: 0.02em !important;
  text-transform: none !important;
  font-size: 0.82rem !important;
  box-shadow: 0 1px 2px rgba(31, 62, 33, 0.08) !important;
  transition: box-shadow 0.2s ease, background-color 0.2s ease,
    border-color 0.2s ease, transform 0.2s ease !important;
}
.v-btn.cal-action-btn:hover {
  background: #eef8ee !important;
  border-color: #5cb860 !important;
  box-shadow: 0 4px 12px rgba(92, 184, 96, 0.28) !important;
  transform: translateY(-1px);
}
.v-btn.cal-action-btn:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(92, 184, 96, 0.2) !important;
}
.calendar-container {
  border: 1.5px solid #5cb860 !important;
  border-radius: 3px !important;
}

.calendar-settings-bar {
  display: flex;
  gap: 10px;
  border-radius: 8px;
}

.calendar-settings-bar .v-btn-toggle {
  border: 1.5px solid #5cb860 !important;
  border-radius: 6px !important;
  overflow: hidden;
  box-shadow: none !important;
}
.calendar-settings-bar .v-btn-toggle .v-btn {
  height: 28px !important;
  padding: 0 12px !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background-color: #fff !important;
  color: #5cb860 !important;
  font-weight: 600 !important;
  font-size: 0.78rem !important;
  text-transform: none !important;
}
.calendar-settings-bar .v-btn-toggle .v-btn--active {
  background-color: #5cb860 !important;
  color: #fff !important;
}
</style>
